import { render, staticRenderFns } from "./SidebarProductStockBlock.vue?vue&type=template&id=a7586e3c&scoped=true"
import script from "./SidebarProductStockBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarProductStockBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarProductStockBlock.vue?vue&type=style&index=0&id=a7586e3c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7586e3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7586e3c')) {
      api.createRecord('a7586e3c', component.options)
    } else {
      api.reload('a7586e3c', component.options)
    }
    module.hot.accept("./SidebarProductStockBlock.vue?vue&type=template&id=a7586e3c&scoped=true", function () {
      api.rerender('a7586e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarProductStockBlock.vue"
export default component.exports